import axios from 'axios';

const normalizeApiBaseUrl = () => {
  const rawBaseUrl = process.env.REACT_APP_API_URL || '';
  const trimmedBaseUrl = rawBaseUrl.trim().replace(/\/+$/, '');

  if (!trimmedBaseUrl) return '/api';
  return trimmedBaseUrl.endsWith('/api')
    ? trimmedBaseUrl
    : `${trimmedBaseUrl}/api`;
};

const okamApi = axios.create({
  baseURL: normalizeApiBaseUrl(),
  timeout: 8000
});

const resolveMediaUrl = (mediaUrl) => {
  if (!mediaUrl || /^https?:\/\//i.test(mediaUrl)) return mediaUrl;

  const apiBaseUrl = normalizeApiBaseUrl();
  const apiOrigin = /^https?:\/\//i.test(apiBaseUrl)
    ? new URL(apiBaseUrl).origin
    : window.location.origin;

  return new URL(mediaUrl, apiOrigin).toString();
};

const prepareHlsUrl = (mediaUrl) => {
  // Do not append cookieCheck manually. MediaMTX uses its initial redirect to
  // establish the partitioned cookie required by native iPhone/Safari HLS.
  return resolveMediaUrl(mediaUrl);
};

const getPublicCameraName = (name) => {
  const cameraName = (name || '').trim();
  if (!cameraName) return 'Aile Köyü';

  return cameraName
    .replace(/^VQDG[A-Z0-9]+\s*-\s*/iu, '')
    .replace(/Çocuk Oyun Köyü/giu, 'Aile Köyü');
};

const withResolvedMediaUrls = (camera) => ({
  ...camera,
  name: getPublicCameraName(camera?.name),
  hlsUrl: prepareHlsUrl(camera?.hlsUrl),
  webRtcUrl: resolveMediaUrl(camera?.webRtcUrl)
});

const flattenDevice = (device) => {
  const views = Array.isArray(device?.views) ? device.views : [];
  return views.map((view) => withResolvedMediaUrls({
    ...view,
    id: `${device.deviceKey}--${view.viewKey}`,
    deviceKey: device.deviceKey,
    viewKey: view.viewKey,
    name: view.name === 'Ana Kamera'
      ? device.name
      : `${device.name} - ${view.name}`,
    enabled: device.enabled && view.enabled
  }));
};

const parseCameraId = (cameraId) => {
  const separatorIndex = cameraId.indexOf('--');
  if (separatorIndex <= 0 || separatorIndex === cameraId.length - 2) {
    throw new Error('Geçersiz kamera kimliği.');
  }

  return {
    deviceKey: cameraId.slice(0, separatorIndex),
    viewKey: cameraId.slice(separatorIndex + 2)
  };
};

export const getOkamCameras = async () => {
  const response = await okamApi.get('/okam/cameras');

  return {
    enabled: response.data?.enabled === true,
    cameras: Array.isArray(response.data?.cameras)
      ? response.data.cameras.flatMap(flattenDevice)
      : []
  };
};

export const getOkamPlayback = async (cameraId) => {
  const { deviceKey, viewKey } = parseCameraId(cameraId);
  const response = await okamApi.get(
    `/okam/cameras/${encodeURIComponent(deviceKey)}/views/${encodeURIComponent(viewKey)}/playback`,
    { timeout: 20000 }
  );

  return withResolvedMediaUrls(response.data || {});
};

export const getOkamStatus = async (cameraId) => {
  const { deviceKey, viewKey } = parseCameraId(cameraId);
  const response = await okamApi.get(
    `/okam/cameras/${encodeURIComponent(deviceKey)}/views/${encodeURIComponent(viewKey)}/status`
  );

  return withResolvedMediaUrls(response.data || {});
};
